import React from 'react';
import PortalAccessReady from './PortalAccessReady';

export default function PaymentProcessingFB() {
  return <PortalAccessReady />;
}
